import React from 'react'
import {Col, Row} from 'components/Display'
import Button from 'components/Button'
import i18n from 'i18n'
import {Problem} from 'data/types'
import services from 'services'

type SumarizedProblemProps = {
  problem: Problem
}

export default function SumarizedProblem(props: SumarizedProblemProps) {
  return (
    <div>
      <Col className="border-b-2 pb-10 mb-6 px-8">
        <Row className="justify-between">
          <Col>
            <Row className="pt-4">
              <div className="text-itx-gray-dark font-bold text-xs 2xl:text-xl pb-2">{i18n.t('problems.problem')}</div>
            </Row>
            <Row>
              <div className="text-black font-bold text-xl 2xl:text-3xl ">{props.problem.title}</div>
            </Row>
          </Col>
          <Col className="justify-end">
            <Row>
              <Button
                onClick={() => {
                  services.router.selectProblem(props.problem, false)
                }}
                className="py-1 bg-gray-itx-border text-itx-gray-dark border-gray-itx-border"
                content={i18n.t('problems.view')}
              />
            </Row>
          </Col>
        </Row>
      </Col>
    </div>
  )
}
